// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4561":"6686c3a8","6833":"0aaa69c8","8548":"1bf2b1da","8773":"d41129c2"}[chunkId] + ".chunk.css";
};